import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/site/site-routing.module').then(m => m.SiteRoutingModule),
  },
  {
    path: 'cabinet',
    loadChildren: () => import('./pages/cabinet/cabinet-routing.module').then(m => m.CabinetRoutingModule),
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
